module.exports = __webpack_public_path__ + "static/innenBackLogo-86c5cae10788e5873972710fe10819b9.jpg";